import { Injectable } from '@angular/core';
import { Prisma, Substance } from '@prisma/client';
import { Apollo } from 'apollo-angular';
import { CRUDService } from '../../shared/crud/service';

@Injectable({ providedIn: 'root' })
export class SubstanceService extends CRUDService<Substance> {
  constructor(public readonly apollo: Apollo) {
    super(apollo, {
      singular: 'substance',
      plural: 'substances',
      list: `
        ${Prisma.SubstanceScalarFieldEnum.id}
        ${Prisma.SubstanceScalarFieldEnum.name}
      `,
    });
  }
}
